import {NodeAddress, PeerAddress, PeerId} from './state/types/common.js';

export function peerToAddress(nodeId: string, peerId: PeerId): PeerAddress {
    return {type: 'peer', peer: peerId, node: nodeId};
}
export function nodeToAddress(nodeId: string): NodeAddress {
    return {type: 'node', node: nodeId};
}
